module.exports = __webpack_public_path__ + "img/novomatic.476bdc96.png";